function addScrolledClass() {
  document.body.classList.toggle("scrolled", window.scrollY > 0);
}

document.addEventListener("DOMContentLoaded", addScrolledClass);
window.addEventListener("scroll", addScrolledClass, { passive: true });
